<template>
  <th class="sortable-header-cell" :aria-sort="ariaSort" scope="col">
    <button type="button" class="button" @click="handleSort">
      <span class="label">
        <slot />
      </span>
      <SvgIcon :path="sortIcon" size="14" color="disabled" aria-hidden="true" />
    </button>
  </th>
</template>

<script setup lang="ts" generic="TField extends string">
import { computed } from 'vue'
import { mdiSort, mdiSortAscending, mdiSortDescending } from '@mdi/js'

import type { AppTableSortModel } from './app-table-list.types'
import SvgIcon from '../SvgIcon/SvgIcon.vue'

const props = defineProps<{
  field: TField
  sort: AppTableSortModel<TField>
}>()

const isSorted = computed(() => props.sort.field === props.field)

const sortIcon = computed(() => {
  if (!isSorted.value) return mdiSort
  return props.sort.direction === 'desc' ? mdiSortDescending : mdiSortAscending
})

const ariaSort = computed(() => {
  if (!isSorted.value) return 'none'
  return props.sort.direction === 'desc' ? 'descending' : 'ascending'
})

const handleSort = () => {
  void props.sort.toggle(props.field)
}
</script>

<style lang="scss" scoped>
.sortable-header-cell {
  padding: 0;
}

.button {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  min-height: 47px;
  padding: 0 16px;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid var(--color-brand-default);
    outline-offset: -2px;
  }
}

.label {
  flex: 1 1 auto;
}
</style>
